import { ExternalInvitationType, FixMeLater, SubGroup } from "@shared/types";

export interface BaseConfigurationItem<T> {
  constraints: FixMeLater;
  outcome: T;
}

export interface ConfigurationOption {
  value?: string | number;
  name: string | number;
}

export interface ConfigurationItem {
  name: BaseConfigurationItem<string>[];
  data: ConfigurationItem[];
  is_section_header?: BaseConfigurationItem<boolean>[];
  default_display?: BaseConfigurationItem<string>[];
  options?: BaseConfigurationItem<
    ConfigurationOption | ConfigurationOption[]
  >[];
  prefix_type?: BaseConfigurationItem<string | number>[];
  prefix?: BaseConfigurationItem<string | number>[];
  field_type?: BaseConfigurationItem<number>[];
  value?: BaseConfigurationItem<any>[];
  should_display?: BaseConfigurationItem<boolean>[];
  uuid?: string;
  chosen?: boolean;
}

export type IdToValue = Record<number, number | null>;

export interface LiveUpdateChannelsResponse {
  groups_data: SubGroup[];
}

export enum UserImpersonationPermissionLevel {
  NONE = 1,
  READ = 2,
  WRITE = 3,
}

export interface CreateAccountInviteRequest {
  name?: string;
  type?: ExternalInvitationType;
  permission_level?: UserImpersonationPermissionLevel;
  asset_manager_permission_level?: UserImpersonationPermissionLevel;
}
